import { useEffect } from "react";
import ILogoHeaderProps from "components/LogoHeader/ILogoHeaderProps";

import useWindowDimensions from "utils/WindowSize";

import "./LogoHeader.css";
import { formStep } from "types/StepEnums";
import { pagesDictionaryFromEnum } from "utils/NavigationHelper";
import { PagesEnum } from "types/PagesEnum";
import { Logo, LogoSmall } from "assets/customAssets";
import { Enhanced } from "utils/ReactUtils";


const LogoHeader: React.FC<ILogoHeaderProps> = ({ logoExpanded,navigate,location }) => {
	const { width } = useWindowDimensions();


	const onLogoClick = () => {
		var step = Number.parseInt(location.state.newStep ?? "0");
		if (step !== formStep.Home)
			navigate(`/${pagesDictionaryFromEnum[PagesEnum.ReservationForm]}`, {
				state: { newStep: location.state.newStep, reset: true, from: location },
			});
		else if (location.pathname !== `/${pagesDictionaryFromEnum[PagesEnum.ReservationForm]}`) {
			navigate(`/${pagesDictionaryFromEnum[PagesEnum.ReservationForm]}`, {
				state: { newStep: location.state.newStep, from: location },
			});
		}
	};

	useEffect(() => {
		let smallNavbar = document.body.scrollTop > 100 || document.documentElement.scrollTop > 100 || width <= 800;
		document.getElementById("logo-image")!.style.padding = smallNavbar ? "0px" : "20px";
		let navbarHeight = document.getElementById("navbar")!.offsetHeight;
		document.getElementById("app-container")!.style.marginTop = `${navbarHeight}px`;
	}, [width]);

	const getImage = () => {
		var image = (
			<img
				key={Date.now()}
				alt="logo"
				onClick={window.CONFIG.REACT_APP_SITO_VETRINA_LINK ? undefined : onLogoClick}
				onKeyDown={(event) =>{ if (event.key === "Enter"&&!window.CONFIG.REACT_APP_SITO_VETRINA_LINK) {onLogoClick()}}}
				role="presentation"
				src={logoExpanded ? Logo : LogoSmall}
				className={logoExpanded ? "logo-expanded" : "logo-compressed"}
			/>
		);

		return image;
	};

	return (
		<div id="logo-image">
			{window.CONFIG.REACT_APP_SITO_VETRINA_LINK ? (
				<a href={window.CONFIG.REACT_APP_SITO_VETRINA_LINK} target="_blank" rel="noreferrer">
					{getImage()}
				</a>
			) : (
				getImage()
			)}
		</div>
	);
};

export default Enhanced(LogoHeader, {});
